import React, { useEffect, useRef, useState } from 'react';
import { Mic } from 'lucide-react';
import ConfirmDialog from '../ConfirmDialog';
import { ETICHETTA_CONSENSO, TESTO_CONSENSO_REGISTRAZIONE } from './testiAudio';

interface VerbaleConsensoProps {
  aperto: boolean;
  onConferma: () => void;
  onAnnulla: () => void;
  /** Titolo della finestra (predefinito «Prima di registrare»; per un file «Prima di caricare l'audio»). */
  titolo?: string;
}

/** Promemoria prima di registrare o caricare l'audio: «Conferma» solo dopo «Ho informato i presenti». */
const VerbaleConsenso: React.FC<VerbaleConsensoProps> = ({
  aperto, onConferma, onAnnulla, titolo = 'Prima di registrare',
}) => {
  const [spunta, setSpunta] = useState(false);
  // ConfirmDialog chiude (onClose) anche dopo la conferma: quella chiusura non è un annullamento.
  const confermatoRef = useRef(false);

  useEffect(() => {
    if (aperto) {
      setSpunta(false);
      confermatoRef.current = false;
    }
  }, [aperto]);

  return (
    <ConfirmDialog
      isOpen={aperto}
      onClose={() => {
        if (confermatoRef.current) return;
        onAnnulla();
      }}
      onConfirm={() => {
        if (!spunta) return;
        confermatoRef.current = true;
        onConferma();
      }}
      title={titolo}
      message={TESTO_CONSENSO_REGISTRAZIONE}
      confirmText="Conferma"
      confirmDisabled={!spunta}
      type="info"
      icon={<Mic className="h-4 w-4" />}
    >
      <label className="mt-3 flex cursor-pointer items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm font-medium text-slate-800 dark:border-gray-600 dark:bg-gray-700/60 dark:text-gray-100">
        <input
          type="checkbox"
          checked={spunta}
          onChange={(e) => setSpunta(e.target.checked)}
          className="h-4 w-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500 dark:border-gray-500 dark:bg-gray-800"
        />
        {ETICHETTA_CONSENSO}
      </label>
    </ConfirmDialog>
  );
};

export default VerbaleConsenso;
